import React, { Fragment } from "react";
import PropTypes from "kf-proptypes/widgets";

import {
  KfIcon,
  ICON_SIZE,
  ICON_STROKE
} from "@widgets/common/components/primitives/kf_icon/index.jsx";
import { FieldLabel, LABEL_SIZE, ResetDialog } from "@widgets/inputs/index.jsx";

import styles from "./styles.css";

ToggleGroup.propTypes = {
  value: PropTypes.shape({
    id: PropTypes.string
  }),
  dataSource: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string
    })
  ),
  onChange: PropTypes.func,
  label: PropTypes.string,
  isDisabled: PropTypes.bool
};

/**
 *
 * @param {object} props -
 * @param {object} props.value - selected value ={id,name}
 * @param {object[]} props.dataSource - all possible items [{id,name,iconName}]
 * @param {function} props.onChange - onChange fired when user select an item
 * @returns
 */

ToggleGroup.propTypes = {
  value: PropTypes.PropTypes.oneOfType(
    PropTypes.string,
    PropTypes.number,
    PropTypes.bool
  ),
  dataSource: PropTypes.arrayOf(PropTypes.shape({})),
  onChange: PropTypes.func,
  label: PropTypes.string,
  isDisabled: PropTypes.bool,
  showReset: PropTypes.bool,
  className: PropTypes.string,
  onReset: PropTypes.func,
  modified: PropTypes.bool
};
export function ToggleGroup({
  value,
  label,
  dataSource = [],
  onChange,
  isDisabled = false,
  showReset = false,
  onReset = () => {},
  modified = false,
  className = ""
}) {
  function handleSelect(selectedItem) {
    // const selectedItem = dataSource.find(({ id }) => id === selectedItem);

    onChange({ id: selectedItem.id, name: selectedItem.name });
  }

  const Wrapper = label ? LabelContainer : Fragment;

  return (
    <Wrapper
      label={label}
      onReset={onReset}
      showReset={showReset}
      modified={modified}
    >
      <div
        className={`${styles.selectorContainer} ${
          isDisabled ? styles.disabled : ""
        }`}
      >
        {dataSource.map(({ name, id, iconName, icon }) => {
          let isActive = value === id;
          return (
            <div
              key={id}
              className={`${styles.selectableItem} ${
                isActive ? styles.active : ""
              } ${className}`}
              onClick={!isDisabled && (() => handleSelect({ name, id }))}
            >
              {iconName ? (
                <KfIcon
                  icon={iconName}
                  size={ICON_SIZE.SIZE_16}
                  stroke={ICON_STROKE.THIN}
                  color={isActive ? "--kf-color-primary-500" : ""}
                />
              ) : (
                icon
              )}
              <p className="small ellipsis">{name}</p>
            </div>
          );
        })}
      </div>
    </Wrapper>
  );
}

LabelContainer.propTypes = {
  label: PropTypes.string,
  children: PropTypes.node,
  showReset: PropTypes.bool,
  onReset: PropTypes.func,
  modified: PropTypes.bool
};

function LabelContainer({
  children,
  label,
  showReset = true,
  onReset,
  modified
}) {
  return (
    <div>
      <div className={styles.titleContainer}>
        <div className={styles.title}>
          <FieldLabel label={label} size={LABEL_SIZE.MEDIUM} />
        </div>
        {showReset && modified && (
          <div>
            <ResetDialog onReset={onReset} />
          </div>
        )}
      </div>
      {children}
    </div>
  );
}
